module.exports = __webpack_public_path__ + "static/media/gallery_2_6.c7e5e63e.jpg";